import { render, staticRenderFns } from "./WorkFlowOrgPersonSelectList.vue?vue&type=template&id=6c195024"
import script from "./WorkFlowOrgPersonSelectList.vue?vue&type=script&lang=js"
export * from "./WorkFlowOrgPersonSelectList.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowOrgPersonSelectList.vue?vue&type=style&index=0&id=6c195024&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports